module.exports = __webpack_public_path__ + "img/10979925_L.327b2946.png";